import { useState } from "react";

interface FlashcardsStudySession {
  flippedByIndex: Record<number, boolean>;
  flipCard: (index: number) => void;
}

/**
 * Tracks which study-card faces are showing — used so each card in the picker
 * study pane can be turned independently.
 */
const useFlashcardsStudySession = (): FlashcardsStudySession => {
  const [flippedByIndex, setFlippedByIndex] = useState<Record<number, boolean>>(
    {}
  );

  const flipCard = (index: number) => {
    setFlippedByIndex((current) => ({
      ...current,
      [index]: !current[index],
    }));
  };

  return { flippedByIndex, flipCard };
};

export { useFlashcardsStudySession };
